import { useSelector } from "react-redux";

import { selectCurrentUser } from "@/store/app/bootstrap/bootstrap";

/** Returns the details of user that is currently logged in
 * @type User
 * @returns the user
 */
export const useUser = () => {
  const currentUser = useSelector(selectCurrentUser);

  return { currentUser };
};
